import Swiper, { Navigation, Pagination } from "swiper";

export default class ComponentRelatorios {
    constructor() {

        this.slider = document.querySelector(".swiper--component-relatorios")
        this.navigationPrev = document.querySelector(".slider-button-prev--component-relatorios")
        this.navigationNext = document.querySelector(".slider-button-next--component-relatorios")
        this.pagination = document.querySelector(".slider-pagination--component-relatorios")

        this.ready();
    }

    ready() {

        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination],
            grabCursor: true,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev
            },
            pagination: {
                el: this.pagination,
                clickable: true,                
                type: "fraction",
            },
            slidesPerView: 1.7,
            spaceBetween: 22,
            slidesOffsetBefore: 22,
            slidesOffsetAfter: 22
        })
        
    }
}